import {useMemo} from 'react';
import {useComputedOnboardingDetails} from 'hooks/useComputedOnboardingDetails';

const ONBOARDING_STEPS = {
  reservationType: 'reservation-type',
  numberOfGuest: 'number-of-guest',
  whoIsComing: 'who-is-coming',
  whoIsInCharge: 'confirm-leader-guest',
};

function useOnboardingSteps() {
  const {
    shouldAskReservationGroup,
    shouldAskListOfParticipants,
    shouldAskNumberOfGuests,
    shouldAskLeaderGuest,
  } = useComputedOnboardingDetails();

  const steps = useMemo(() => {
    const steps = {
      [ONBOARDING_STEPS.reservationType]: shouldAskReservationGroup,
      [ONBOARDING_STEPS.numberOfGuest]: shouldAskNumberOfGuests,
      [ONBOARDING_STEPS.whoIsComing]: shouldAskListOfParticipants,
      [ONBOARDING_STEPS.whoIsInCharge]: shouldAskLeaderGuest,
    };

    return Object.entries(steps)
      ?.filter(([_, active]) => active)
      .map(([step]) => step);
  }, [
    shouldAskLeaderGuest,
    shouldAskListOfParticipants,
    shouldAskNumberOfGuests,
    shouldAskReservationGroup,
  ]);

  return {
    steps,
  };
}

export {useOnboardingSteps};
